import api from "./api";

class SottoprogettoDocumentiFornitoreManager {

    updateSottoprogettoDocumentiFornitore(documento_id: number | string, data: any) {
        return api.put(`/sottoprogetto_documenti_fornitore/${documento_id}/`, data)
    }

}

const sottoprogettoDocumentiFornitoreManager = new SottoprogettoDocumentiFornitoreManager()

export default sottoprogettoDocumentiFornitoreManager
